module.exports = __webpack_public_path__ + "img/car-E-1.8f3e99a4.jpg";